(function() {
	/**
     * Toggle main hamburger menu
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
    const menuButton = document.querySelector('#js-hamburger-button');
    const overlay    = document.querySelector('#js-overlay');

    function toggleMenu(){
        let navigation = document.querySelector('#js-menu-primary');
        let expanded   = menuButton.getAttribute('aria-expanded') === 'true' || false;

        //Toggle menu on hamburger click and only close it on overlay click or ESC key press
        if((this.id === menuButton.id ) || ((this.id === overlay.id || event.keyCode == 27) && expanded === true)) {
            //Toggle visibility classes
            navigation.classList.toggle('-is-visible');
            menuButton.classList.toggle('-is-open');
            overlay.classList.toggle('-is-visible');

            //Toggle the aria-expande attribute
            menuButton.setAttribute('aria-expanded', !expanded);
        }  
	}
	if ( menuButton ) {
		menuButton.onclick = toggleMenu;
		overlay.onclick = toggleMenu;
		//Close menu with ESC key press
		document.body.onkeydown = function(event){
			if ( event.keyCode == 27 ) {
				toggleMenu();            
			}
		};
	}
	

    /**
     * Remove :focus outline unless user is using the keyboard to navigate
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
    function handleFirstTab(e) {
		if (e.keyCode === 9) {
			document.body.classList.add('h-user-is-tabbing');
			window.removeEventListener('keydown', handleFirstTab);
			window.addEventListener('mousedown', handleMouseDownOnce);
		}
	}
	function handleMouseDownOnce() {
		document.body.classList.remove('h-user-is-tabbing');
		window.removeEventListener('mousedown', handleMouseDownOnce);
		window.addEventListener('keydown', handleFirstTab);
	}
    window.addEventListener('keydown', handleFirstTab);



	/**
     * Disable animations on resize
     *
     * @author      Andy Bell
     * @version     1.0.0
     * @see         https://css-tricks.com/stop-animations-during-window-resizing/
     */
	let resizeTimer;
	window.addEventListener("resize", () => {
		document.body.classList.add("js-resize-animation-stopper");
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			document.body.classList.remove("js-resize-animation-stopper");
		}, 400);
	});


	/**
     * Toggle popup form
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
	const showPopup = document.querySelector('#js-show-popup');
	const hidePopup = document.querySelector('#js-hide-popup');

    function togglePopup(){
        let formPopup = document.querySelector('#js-popup');
		
        //Toggle menu on hamburger click and only close it on overlay click or ESC key press
        if((this.id === showPopup.id) || (this.id === hidePopup.id) || (event.keyCode == 27 && formPopup.classList.contains('-is-visible'))) {
            //Toggle visibility classes
            formPopup.classList.toggle('-is-visible');
            overlay.classList.toggle('-is-visible');
        }  
	}
		if ( showPopup ) {
		showPopup.onclick = togglePopup;
		hidePopup.onclick = togglePopup;
		//Close menu with ESC key press
		document.body.onkeydown = function(event){
			if ( event.keyCode == 27 ) {
				togglePopup();            
			}
		};
	}


	/**
     * Toggle report error form
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
	const showForm = document.querySelector('#js-show-error-form');
	const hideForm = document.querySelector('#js-hide-error-form');

    function toggleForm(){
        let errorForm = document.querySelector('#report-form');
		
        //Toggle menu on hamburger click and only close it on overlay click or ESC key press
        if((this.id === showForm.id) || (this.id === hideForm.id) || (event.keyCode == 27 && formPopup.classList.contains('-is-visible'))) {
            //Toggle visibility classes
            errorForm.classList.toggle('-is-visible');
			showForm.classList.toggle('-is-hidden');
			hideForm.classList.toggle('-is-hidden');
        }  
	}
	if ( showForm ) {
		showForm.onclick = toggleForm;
		hideForm.onclick = toggleForm;
		//Close menu with ESC key press
		document.body.onkeydown = function(event){
			if ( event.keyCode == 27 ) {
				togglePopup();            
			}
		};
	}
})();

(function($) {

	const estamento = document.querySelector('.js-data-estamento');
	const applyFilters = document.querySelector('.c-filters__button--apply');
	// Add Facet title
	$(document).on('facetwp-loaded', function() {
		$('.facetwp-facet').each(function() {
			var $facet = $(this);
			var facet_name = $facet.attr('data-name');
			var facet_label = FWP.settings.labels[facet_name];

			if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
					$facet.wrap('<div class="facet-wrap"></div>');
					$facet.before('<h4 class="facet-label">' + facet_label + '</h4>');
			}
		});
		if (FWP.loaded) {
			$('html, body').animate({
					scrollTop: $('.facetwp-template').offset().top
			}, 500);
		}
	});

	// Disable FWP auto-refresh
	$(function() {
		if ('undefined' !== typeof FWP) {
				FWP.auto_refresh = false;
		}
	});

	// Show current selection on print page
	$(document).on('facetwp-loaded', function() {
		if (estamento){
			if (FWP.facets.estamento.length > 0) {
				estamento.textContent = FWP.facets.estamento;
			} else {
				estamento.textContent = 'Todo';
			}
		}
	});
})(jQuery);